import { useState } from 'react';

export function useNodeHistory(initialNodeId: string) {
  const [history, setHistory] = useState<string[]>([initialNodeId]);
  const [index, setIndex] = useState(0);

  const visit = (nodeId: string) => {
    setHistory((prev) => {
      const newHistory = [...prev.slice(0, index + 1), nodeId];
      return newHistory;
    });
    setIndex((prev) => prev + 1);
  };

  const back = (): string | null => {
    if (index > 0) {
      const newIndex = index - 1;
      setIndex(newIndex);
      return history[newIndex];
    }
    return null;
  };

  const forward = (): string | null => {
    if (index < history.length - 1) {
      const newIndex = index + 1;
      setIndex(newIndex);
      return history[newIndex];
    }
    return null;
  };

  return {
    visit,
    back,
    forward,
    canBack: index > 0,
    canForward: index < history.length - 1,
  };
}
